(function () {

    'use strict';

    angular.module('asys')
        .controller('ModalAngebotNichtAenderbarController', ModalAngebotNichtAenderbarController);

    ModalAngebotNichtAenderbarController.$inject = [
        '$modalInstance',
        '$log',
        'lodash',
        'AppConfig',
        'content',
        'type'
    ];

    function ModalAngebotNichtAenderbarController($modalInstance, $log, _, AppConfig, content, type) {
        var vm = this;

        $log.debug('ModalAngebotNichtAenderbarController', vm);

        vm.onOk = onOk;
        vm.onCancel = onCancel;
        vm.isBtnOkErlaubt = isBtnOkErlaubt;

        activate();

        function activate() {
            vm.content = content;

            if (type === 'NEU') {
                vm.btnOkDesc = 'Neue Tarifauskunft';
            } else if (type === 'KOPIEREN') {
                vm.btnOkDesc = 'Kopieren und bearbeiten';
            } else {
                vm.btnOkDesc = null;
            }
        }
        function onOk() {
            $modalInstance.close();
        }
        function onCancel() {
            $modalInstance.dismiss('cancel');
        }
        function isBtnOkErlaubt() {
            return (
                vm.btnOkDesc &&
                _.get(AppConfig, 'MODAL.angebotNichtAenderbar.buttonOk')
            );
        }
    }

})();
